import { ref } from "vue";
import { useRouter } from "vue-router";
import { useQuotaStore } from "@/stores/modules/quota/quota";
import { setWarningToast } from "@/helpers/notifications/toast";
import { translate } from "@/i18n/vueI18n";

const addPhotoBottomSheetOpen = ref(false);
const editPhotoBottomSheetOpen = ref(false);
const selectedPhotoData = ref<any>(null);

export function usePhotoManagement() {
  const router = useRouter();
  const quotaStore = useQuotaStore();

  function openAddPhotoBottomSheet() {
    if (quotaStore.isPhotoQuotaExceeded) {
      setWarningToast({
        message: translate("pages.setting.quota.limit_reached"),
      });
      router.push({ name: "settings", query: { showQuota: "true" } });
      return;
    }
    addPhotoBottomSheetOpen.value = true;
  }

  function closeAddPhotoBottomSheet() {
    addPhotoBottomSheetOpen.value = false;
  }

  function openEditPhotoBottomSheet(photoData: any) {
    selectedPhotoData.value = photoData;
    // Use requestAnimationFrame to ensure the transition triggers properly
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        editPhotoBottomSheetOpen.value = true;
      });
    });
  }

  function closeEditPhotoBottomSheet() {
    editPhotoBottomSheetOpen.value = false;
    setTimeout(() => {
      selectedPhotoData.value = null;
    }, 300);
  }

  return {
    addPhotoBottomSheetOpen,
    editPhotoBottomSheetOpen,
    selectedPhotoData,
    openAddPhotoBottomSheet,
    closeAddPhotoBottomSheet,
    openEditPhotoBottomSheet,
    closeEditPhotoBottomSheet,
  };
}
